module.exports = __webpack_public_path__ + "static/media/icon_weblink.ac1c5b48.svg";